import React, { useEffect, useState } from "react";
import { Spin, Table, Tooltip } from "antd";
import dayjs from "dayjs";
import { MdDelete, MdEdit } from "react-icons/md";
import ModalPopup from "../Common/Modal/Modal";
import Verify_Modal from "./Verify_Modal";
import { capitalizeFirstLetter } from "../Common/Captilization";
//import { userStatusActivate } from "../../Api/RequestManagement/RequestManagement";
import { FaEye } from "react-icons/fa";
import Status_Update_Modal from "./Status_Update_Modal";
import UserProfile from "../../asserts/userprofile.png";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";

export default function Operator({ tabfilter,sortOperatorsName,setOperatorsName,sortedData,setSortedData,setOwnerSort,sortOwner,sortNumber,setNumberSort,
  sortEmail,setEmailSort
 }) {
  //const [operatorId, setOperatorId] = useState(null);
  const [verifyData, setVerifyData] = useState("");
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const [isVerifyModal, setIsVerifyModal] = useState(false);
  const [requestData, setRequestData] = useState("");
  const [openStatusModal, setOpenStatusModal] = useState("");
  const [statusFromEdit, SetStatusFromEdit] = useState(false);
  const [isUpdateStatus, setIsUpdateStatus] = useState(false);
  const [spinning, setSpinning] = useState(false)
  const [comments, setComments] = useState("");
  const[statusId,setStatusId]=useState()
    const get_rq_man_data = useSelector(
    (state) => state?.crm?.request_management
  );
    const [activePage, setActivePage] = useState(1);
    const itemsPerPage = 10; // Number of items to display per page
  
    // Calculate pagination slice based on activePage
    const indexOfLastItem = activePage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const data = sortedData?.length > 0 ?
    sortedData?.slice(indexOfFirstItem,
      indexOfLastItem) :
    get_rq_man_data?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );
     const handlePageChange = (pageNumber) => {
       setActivePage(pageNumber);
     };
    const handleCompanyNameSort = () => {
      setOwnerSort(null)
      setNumberSort(null)
      setEmailSort(null)
    let sorted = [...get_rq_man_data];
    if (sortOperatorsName === "ascend") {
      sorted.sort((a, b) => b.company_name.localeCompare(a.company_name));
      setOperatorsName("descend");
    } else if (sortOperatorsName === "descend") {
      sorted = [...get_rq_man_data]; // Reset to original order
      setOperatorsName(null);
    } else {
      sorted.sort((a, b) => a.company_name.localeCompare(b.company_name));
      setOperatorsName("ascend");
    }
    setSortedData(sorted);
  };
  const handleOwnerSort = () => {
      setOperatorsName(null);
    setNumberSort(null)
      setEmailSort(null)
    let sorted = [...get_rq_man_data];
    if (sortOwner === "ascend") {
      sorted.sort((a, b) => b.owner_name.localeCompare(a.owner_name));
      setOwnerSort("descend");
    } else if (sortOwner === "descend") {
      sorted = [...get_rq_man_data]; // Reset to original order
      setOwnerSort(null);
    } else {
      sorted.sort((a, b) => a.owner_name.localeCompare(b.owner_name));
      setOwnerSort("ascend");
    }
    setSortedData(sorted);
  };
   const handleNumberSort = () => {
      setOperatorsName(null);
      setEmailSort(null)
      setOwnerSort(null)
    let sorted = [...get_rq_man_data];
    if (sortNumber === "ascend") {
      sorted.sort((a, b) => b.phone.localeCompare(a.phone));
      setNumberSort("descend");
    } else if (sortNumber === "descend") {
      sorted = [...get_rq_man_data]; // Reset to original order
      setNumberSort(null);
    } else {
      sorted.sort((a, b) => a.phone.localeCompare(b.phone));
      setNumberSort("ascend");
    }
    setSortedData(sorted);
  };

  const handleEmailSort = () => {
    setOperatorsName(null);
      setNumberSort(null)
      setOwnerSort(null)
    let sorted = [...get_rq_man_data];
    if (sortEmail === "ascend") {
      sorted.sort((a, b) => b.emailid.localeCompare(a.emailid));
      setEmailSort("descend");
    } else if (sortEmail === "descend") {
      sorted = [...get_rq_man_data]; // Reset to original order
      setEmailSort(null);
    } else {
      sorted.sort((a, b) => a.emailid.localeCompare(b.emailid));
      setEmailSort("ascend");
    }
    setSortedData(sorted);
  };

  const crud=sessionStorage.getItem("crud_permission")
  const columns = [
    {
      title: (
        <div className="flex justify-center items-center font-bold text-[1.1vw]">
          Logo
        </div>
      ),
      // dataIndex: "photo",
      // key: "photo",
      align: "center",
      render: (row) => {
        const image = `${apiImgUrl}${row?.profileimg}`;
        console.log(row?.profileimg, "imageimage");
        return (
          <div className="flex justify-center items-center">
            <img
              src={`${row?.profileimg ? `${apiImgUrl}${row?.profileimg}` : UserProfile
                } `}
              alt="Photo"
              className="w-[2.15vw] h-[2.15vw] object-cover rounded-[0.2vw]"
            />
          </div>
        );
      },
      width: "6vw",
    },
    {
      title: (
        <div className="flex items-center justify-center font-bold text-[1.1vw]">
          Operator ID
        </div>
      ),
      width: "9vw",
      render: (row) => {
        //console.log("statuus", row.tbs_operator_id);
        return (
          <div className="flex items-center justify-center">
            <h1 className=" text-[1vw] font-bold text-[#1F4B7F]">
              {row?.tbs_operator_id}
            </h1>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex items-center justify-evenly font-bold text-[1.1vw]">
          Operator Name
          <button onClick={handleCompanyNameSort} className="">
                      {sortOperatorsName === "ascend" ? (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      ) : sortOperatorsName === "descend" ? (
                        <Tooltip
                          placement="top"
                          title="Descending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedDown />
                        </Tooltip>
                      ) : sortOperatorsName === null ? (
                        <Tooltip
                          placement="top"
                          title="Unsorted"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowUnsorted />
                        </Tooltip>
                      ) : (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      )}
                    </button>
        </div>
      ),
      // sorter: (a, b) => a.company_name.localeCompare(b.company_name),
      render: (row, rowdta, index) => {
        return (
          <div className="flex items-center font-bold pl-[2vw] text-[1vw] text-[#1F4B7F]">
            {/* <p className="text-[1vw] text-[#1F4B7F]">{row?.owner_name}</p> */}
            {row?.company_name?.length > 15 ? (
              <Tooltip
                color="white"
                overlayInnerStyle={{ color: "#1F4B7F" }}
                placement="bottom"
                // title={row?.owner_name}
                title={row.company_name}
                className="cursor-pointer"
              // color="#1F487C"
              >
                {`${row?.company_name?.charAt(0) === row?.company_name?.charAt(0)?.toLowerCase()
                  ? capitalizeFirstLetter(row?.company_name).slice(0, 15)
                  : row?.company_name?.slice(0, 15)}...`}
              </Tooltip>
            ) : (
              row?.company_name?.charAt(0) === row?.company_name?.charAt(0)?.toLowerCase()
                ? capitalizeFirstLetter(row?.company_name).slice(0, 15)
                : row?.company_name?.slice(0, 15)
            )}
          </div>
        );
      },
      width: "14vw",
    },
    {
      title: (
        <div className="flex items-center justify-evenly font-bold text-[1.1vw]">
          Owner Name
          <button onClick={handleOwnerSort} className="">
                      {sortOwner === "ascend" ? (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          coverlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      ) : sortOwner === "descend" ? (
                        <Tooltip
                          placement="top"
                          title="Descending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedDown />
                        </Tooltip>
                      ) : sortOwner === null ? (
                        <Tooltip
                          placement="top"
                          title="Unsorted"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowUnsorted />
                        </Tooltip>
                      ) : (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      )}
                    </button>
        </div>
      ),
      // sorter: (a, b) => a.owner_name.localeCompare(b.owner_name),
      render: (row, rowdta, index) => {
        return (
          <div className="flex items-center font-bold pl-[1.5vw] text-[1vw] text-[#1F4B7F]">
            {/* <p className="text-[1vw] text-[#1F4B7F]">{row?.owner_name}</p> */}
            {row?.owner_name?.length > 15 ? (
              <Tooltip
                color="white"
                overlayInnerStyle={{ color: "#1F4B7F" }}
                placement="bottom"
                // title={row?.owner_name}
                title={row.owner_name}
                className="cursor-pointer"
              // color="#1F487C"
              >
                {`${row?.owner_name?.charAt(0) === row?.owner_name?.charAt(0).toLowerCase()
                  ? capitalizeFirstLetter(row?.owner_name).slice(0, 15)
                  : row?.owner_name.slice(0, 15)}...`}

              </Tooltip>
            ) : (
              row?.owner_name?.charAt(0) === row?.owner_name?.charAt(0).toLowerCase()
                ? capitalizeFirstLetter(row?.owner_name).slice(0, 15)
                : row?.owner_name?.slice(0, 15)
            )}
          </div>
        );
      },
      width: "14vw",
    },
    {
      title: (
        <div className="flex items-center justify-evenly font-bold text-[1.1vw]">
          Mobile
          <button onClick={handleNumberSort} className="">
                      {sortNumber === "ascend" ? (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      ) : sortNumber === "descend" ? (
                        <Tooltip
                          placement="top"
                          title="Descending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedDown />
                        </Tooltip>
                      ) : sortNumber === null ? (
                        <Tooltip
                          placement="top"
                          title="Unsorted"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowUnsorted />
                        </Tooltip>
                      ) : (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      )}
                    </button>
        </div>
      ),
      // sorter: (a, b) => a.phone.localeCompare(b.phone),
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            <p className="text-[1vw] text-[#1F4B7F]">{row?.phone}</p>
          </div>
        );
      },
      width: "11vw",
    },

    {
      title: (
        <div className="flex items-center justify-evenly font-bold text-[1.1vw]">
          Email
          <button onClick={handleEmailSort} className="">
                      {sortEmail === "ascend" ? (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      ) : sortEmail === "descend" ? (
                        <Tooltip
                          placement="top"
                          title="Descending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedDown />
                        </Tooltip>
                      ) : sortEmail === null ? (
                        <Tooltip
                          placement="top"
                          title="Unsorted"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowUnsorted />
                        </Tooltip>
                      ) : (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          overlayStyle={{pointerEvents:'none'}}
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      )}
                    </button>
        </div>
      ),
      // sorter: (a, b) => a.emailid.localeCompare(b.emailid),
      render: (row) => {
        return (
          // <div className="flex items-center justify-center">
          //   <p className="text-[1vw] text-[#1F4B7F]">{row?.emailid}</p>
          // </div>
          <div className="pl-[1.5vw]">
            {row?.emailid?.length > 25 ? (
              <Tooltip
                color="white"
                overlayInnerStyle={{ color: "#1F4B7F" }}
                placement="top"
                title={row?.emailid}
                className="cursor-pointer"
              >
                <div className="text-[1vw]  text-[#1f4b7f]">
                  {" "}
                  {`${row?.emailid?.slice(0, 25)}...`}
                </div>
              </Tooltip>
            ) : (
              <div className="text-[1vw]  text-[#1f4b7f]">
                {row?.emailid?.slice(0, 25)}
              </div>
            )}
          </div>
        );
      },
      width: "17vw",
    },

    {
      title: (
        <div className="flex items-center justify-center font-bold text-[1.1vw]">
          Created Date
        </div>
      ),
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            <p className="text-[1vw] text-[#1F4B7F]">{`${dayjs(
              row?.created_date
            ).format("DD MMM, YY ")}`}</p>
          </div>
        );
      },
      width: "12vw",
    },
    // {
    //   title: (
    //     <div className="flex items-center justify-center font-bold text-[1.2vw]">
    //       Documents
    //     </div>
    //   ),
    //   render: (row) => {
    //     console.log(row.tbs_operator_id, "row.tbs_operator_id");
    //     return (
    //       <div className="flex gap-[0.7vw] justify-center">
    //         {/* <button
    //         type="button"
    //         class="text-white font-bold text-[0.9vw] bg-[#41C6FF]  rounded-[0.5vw]  w-[5vw] py-[0.1vw]"
    //         onClick={() => {
    //           setIsVerifyModal(true);
    //           setVerifyData(row.operator_id);
    //         }}
    //       >
    //         {capitalizeFirstLetter("Verify")}
    //       </button> */}
    //         <button
    //           type="button"
    //           className="text-white bg-[#727070] flex items-center justify-center rounded-[0.5vw]  text-[1vw] w-[6vw] py-[0.2vw]
    //          "
    //           onClick={() => {
    //             setIsVerifyModal(true);
    //             setVerifyData(row.tbs_operator_id);
    //             SetStatusFromEdit(false)
    //           }}
    //         >
    //           <span>
    //             <FaEye size={"1vw"} color="white" />
    //           </span>
    //           <span className="pl-[0.5vw]">
    //             {" "}
    //             {capitalizeFirstLetter("Verify")}
    //           </span>
    //         </button>
    //       </div>
    //     );
    //   },
    // },
    {
      title: (
        <div className="flex justify-center font-bold text-[1.1vw]">Status</div>
      ),
      render: (row) => {
        // console.log("statuus", row.req_status);
        return (
          <div className="flex items-center justify-center">
            <button
              onClick={() => {
                if(!crud?.includes("view")){ 
                // setIsVerifyModal(true);
                setVerifyData(row.tbs_operator_id);
                // SetStatusFromEdit(true)
                setIsUpdateStatus(true);
                setComments(row.comments);
                setStatusId(row.req_status_id)
                }
              }}
              disabled={row.req_status_id === 1 ? true : false}
              className={`${
                // row?.req_status_id == 2
                //   ? "bg-[#34AE2A]"
                //   : row?.req_status_id == 0
                //   ? "bg-[#FFD600]"
                //   : row?.req_status_id == 3
                //   ? "bg-[#e60f00]"
                //   : row?.req_status_id == 1
                //   ? "bg-[#FF6B00]"
                //   : "bg-blue"
                // row?.req_status_id == 0
                //   ? "bg-[#FF6B00]"
                //   : row?.req_status_id == 1
                //     ? "bg-[#2A99FF]"
                //     : row?.req_status_id == 2
                //       ? "bg-[#34AE2A]"
                //       : row?.req_status_id == 3
                //         ? "bg-[#e60f00]"
                //         : "bg-[#646262]"
                row?.req_status_id == 1
                  ? "bg-[#FF9900] cursor-not-allowed"
                  : row?.req_status_id == 4
                    ? "bg-[#2A99FF]"
                    : row?.req_status_id == 5
                      ? "bg-[#34AE2A]"
                      : row?.req_status_id == 6
                        ? "bg-[#FD3434]"
                        : "bg-[#646262]"
                } rounded-[0.5vw] text-[1vw]  font-extrabold shadow-md shadow-black text-white w-[7vw] py-[0.2vw] ${crud?.includes("view")||row?.req_status_id==1?"cursor-not-allowed":"cursor-pointer"}`}
            >
              {capitalizeFirstLetter(row?.req_status)}
            </button>
          </div>
        );
      },
      width: "10vw",
    },
    {
      title: (
        <div className="flex items-center justify-center font-bold text-[1.1vw]">
          Action
        </div>
      ),
      render: (row) => {
        console.log(row.tbs_operator_id, "row.tbs_operator_id");
        return (
          <div className="flex justify-center">
            <div className="flex justify-between  px-[1vw]">
              {/* <button
            type="button"
            class="text-white font-bold text-[0.9vw] bg-[#41C6FF]  rounded-[0.5vw]  w-[5vw] py-[0.1vw]"
            onClick={() => {
              setIsVerifyModal(true);
              setVerifyData(row.operator_id);
            }}
          >
            {capitalizeFirstLetter("Verify")}
          </button> */}

              <span
                className="cursor-pointer"
                onClick={() => {
                  setIsVerifyModal(true);
                  setVerifyData(row?.tbs_operator_id);
                  SetStatusFromEdit(false);
                }}
              >
                <FaEye size={"1.3vw"} color="#1F4B7F" />
              </span>
              {/* {
                row.req_status_id === 0 ? "" :(
                  <MdEdit
                  size={"1.3vw"}
                  color="#1F4B7F"
                  className=" cursor-pointer"
                  // onClick={() => setOpenStatusModal(true)}
                  onClick={() => {
                    // setIsVerifyModal(true);
                    setVerifyData(row.tbs_operator_id);
                    // SetStatusFromEdit(true)
                    setIsUpdateStatus(true)
  
                  }}
                />

                )
              } */}
              {/* <div>
                <MdEdit
                  size={"1.3vw"}
                  color="#1F4B7F"
                  className={`cursor-pointer ${
                    row.req_status_id === 1 ? "hidden" : ""
                  }`}
                  // onClick={() => setOpenStatusModal(true)}
                  onClick={() => {
                    // setIsVerifyModal(true);
                    setVerifyData(row.tbs_operator_id);
                    // SetStatusFromEdit(true)
                    setIsUpdateStatus(true);
                    setComments(row.comments);
                  }}
                />
              </div> */}

              {/* <MdDelete
                size={"1.3vw"}
                color="#1F4B7F"
                className=" cursor-pointer"
              /> */}
            </div>
          </div>
        );
      },
      width: "7vw",
    },
    // {
    //   title: (
    //     <div className="flex items-center justify-center font-bold text-[1.2vw]">
    //       Action
    //     </div>
    //   ),
    //   render: (row) => {
    //     setOperatorId(row.tbs_operator_id);
    //     //console.log(row.tbs_operator_id, "------operator Id");
    //     return (
    //       <div className="flex gap-[0.7vw] justify-center items-center">
    //         {/* {row?.req_status_id==1?( <MdEdit
    //           size={"1.3vw"}
    //           color="#1F4B7F"
    //           className=" cursor-pointer"
    //         />):(row?.req_status_id==2)?(<MdEdit
    //           size={"1.3vw"}
    //           color="#1F4B7F"
    //           className=" cursor-pointer"
    //         />):(row?.req_status_id==3)?(<MdEdit
    //           size={"1.3vw"}
    //           color="#1F4B7F"
    //           className=" cursor-pointer"
    //         />):("")} */}
    //         {row?.req_status_id === 1 ||
    //           // row?.req_status_id === 2 ||
    //           row?.req_status_id === 3 ? (
    //           <MdEdit
    //             size={"1.3vw"}
    //             color="#1F4B7F"
    //             className=" cursor-pointer"
    //             // onClick={() => setOpenStatusModal(true)}
    //             onClick={() => {
    //               setIsVerifyModal(true);
    //               setVerifyData(row.tbs_operator_id);
    //               SetStatusFromEdit(true)

    //             }}
    //           />
    //         ) : (
    //           ""
    //         )}

    //         {/* <MdEdit
    //           size={"1.3vw"}
    //           color="#1F4B7F"
    //           className=" cursor-pointer"
    //         /> */}
    //         {/* <MdDelete
    //           size={"1.3vw"}
    //           color="#1F4B7F"
    //           className=" cursor-pointer"
    //         /> */}
    //       </div>
    //     );
    //   },
    // },
  ];

  const closeModal = () => {
    setIsVerifyModal(false);
    setOpenStatusModal(false);
    setVerifyData("");
    setIsUpdateStatus(false);
  };

  return (
    <>
      {spinning === true ? (
        <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-20  z-10">
          <Spin size="large" />
        </div>
      ) : ""}
     <div className="h-[72vh] w-full">
             <Table
               dataSource={data}
               columns={columns}
               pagination={false}
               className="custom-table"
             />
           </div>
      <div>
        {get_rq_man_data?.length > 10 ? (
            <div className="w-full h-[8vh] flex justify-between items-center ">
              <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw]">
                <span>Showing</span>
                <span className="font-bold">
                  {data && data?.length > 0 ? (
                    <div>
                      {indexOfFirstItem + 1} -{" "}
                      {indexOfFirstItem + data?.length}
                    </div>
                  ) : (
                    "0"
                  )}
                </span>
                <span>from</span>
                <span className="font-bold">
                  {get_rq_man_data?.length > 0 ? get_rq_man_data?.length : 0}
                </span>
                <span>data</span>
              </div>
              <div>
                <ReactPaginate
                  activePage={activePage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={get_rq_man_data?.length}
                  pageRangeDisplayed={3}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  activeClass="active"
                  prevPageText={
                    <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                  }
                  nextPageText={
                    <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                  }
                  firstPageText={
                    <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                  }
                  lastPageText={
                    <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                  }
                />
              </div>
            </div>
          ) : (
            ""
          )}
      </div>  

      <ModalPopup
        className="border border-[#1f487c] border-b-8 border-r-8 border-b-[#1f487c] border-r-[#1f487c] rounded-md"
        show={isVerifyModal}
        closeicon={false}
        onClose={closeModal}
        height="35vw"
        width="60vw"
      >
        <Verify_Modal
          verifyData={verifyData}
          setVerifyData={setVerifyData}
          setRequestData={setRequestData}
          requestData={requestData}
          setIsVerifyModal={setIsVerifyModal}
          statusFromEdit={statusFromEdit}
          comments={comments}
          tabfilter={tabfilter}
          setSpinning={setSpinning}
        />
      </ModalPopup>
      <ModalPopup
        className="border border-[#1f487c] border-b-8 border-r-8 p-[1vw] border-b-[#1f487c] border-r-[#1f487c] rounded-md"
        show={isUpdateStatus}
        closeicon={false}
        onClose={closeModal}
        height="auto"
        width="auto"
      >
        <Status_Update_Modal
          setIsSaveModal={setIsUpdateStatus}
          currentid={verifyData}
          verifyData={verifyData}
          setVerifyData={setVerifyData}
          setRequestData={setRequestData}
          requestData={requestData}
          setIsVerifyModal={setIsVerifyModal}
          comments={comments}
          tabfilter={tabfilter}
          setSpinning={setSpinning}
          statusId={statusId}
        />
      </ModalPopup>

      <ModalPopup show={openStatusModal} onClose={closeModal}>
        <Status_Update_Modal
          currentid
          setIsSaveModal
          setIsVerifyModal
          verifyData
          setVerifyData
          setRequestData
          requestData
        />
      </ModalPopup>
    </>
  );
}
